import { render, staticRenderFns } from "./site-usp.vue?vue&type=template&id=17638f97&"
import script from "./site-usp.vue?vue&type=script&lang=js&"
export * from "./site-usp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports